var FlightState = /* @__PURE__ */ ((FlightState2) => {
  FlightState2["NotSet"] = "NotSet";
  FlightState2["Running"] = "Running";
  FlightState2["Stopped"] = "Stopped";
  return FlightState2;
})(FlightState || {});
export {
  FlightState
};
//# sourceMappingURL=FlightModels.js.map
